module.exports = __webpack_public_path__ + "public/img/yuanb.a79f59a4.png";